<form [formGroup]="labSampleForm"  class="example-form w-100 mb-2" style="height:auto; overflow-y: auto;"><!--(ngSubmit)="onSubmit()"-->
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.labSampleForm.materialID' | translate}}</mat-label>
        <input formControlName="materialID" matInput type="text">
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.labSampleForm.type' | translate}}</mat-label>
        <mat-select formControlName="type">
            <mat-option *ngFor="let method of dropdownType" [value]="method">{{method.title}}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="w-100" *ngIf="data.data?.result">
        <mat-label>{{'FORM.labSampleForm.result' | translate}}</mat-label>
        <input formControlName="result" matInput type="text" readonly>
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.labSampleForm.comment' | translate}}</mat-label>
        <textarea formControlName="comment" matInput></textarea>
    </mat-form-field>

    <div *ngFor =" let examination of labSampleForm.value.examinations; let index = index" class="list-group my-1">
        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.approvalTimestamp' | translate}}: </span>
            <span>{{examination?.approvalTimestamp ? (examination.approvalTimestamp.toDate() | date: 'dd.MM.yyyy, HH:mm') : undefined}}</span>
            <!-- <span>{{getDateFromat(examination.approvalTimestamp).toDate() | date: 'dd.MM.yyyy, HH:mm'}}</span> -->
        </div>

        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.checkDate' | translate}}: </span>
            <span>{{examination?.checkDate ? (examination.checkDate.toDate() | date: 'dd.MM.yyyy, HH:mm') : undefined}}</span>
        </div>

        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.examinationDisease' | translate}}: </span>
            <span>{{examination.examinationDisease}}</span>
        </div>
        
        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.examinationMethod' | translate}}: </span>
            <span>{{examination.examinationMethod}}</span>
        </div>
        
        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.receiptDate' | translate}}: </span>
            <span>{{examination?.receiptDate ? (examination.receiptDate.toDate() | date: 'dd.MM.yyyy, HH:mm') : undefined}}</span>
        </div>
        
        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.result' | translate}}: </span>
            <span>{{examination.result}}</span>
        </div>

        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.resultValue' | translate}}: </span>
            <span>{{examination.resultValue}}</span>
        </div>
    </div>
</form>

<div class="sticky-bottom">
    <button [disabled]="!canSave" class="first-btn w-100 my-1" (click)="onSubmit()" mat-raised-button ><!--type="submit"-->
        {{ 'FORM.BTN_SAVE' | translate }}
    </button>

    <button [disabled]="!canDelete" class="second-btn w-100 my-1" mat-button type="button" (click)="onDelete()">
        {{ 'FORM.BTN_DELETE' | translate }}
    </button>
</div>